module.exports = __webpack_public_path__ + "img/199-sudan.1955fda1.svg";